/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes,extraRequire}
 * tslint:disable
 */
var styles = [".mydp[_ngcontent-%COMP%]   .selector[_ngcontent-%COMP%]{height:auto!important}.mydp[_ngcontent-%COMP%]   .icon-mydpcalendar[_ngcontent-%COMP%]:before{color:#000!important}.datePicker[_ngcontent-%COMP%]{width:350px;font-size:18px!important;font-family:Calibre}"];
export { styles as styles };

